export default __webpack_public_path__ + "static/media/logo_fadu_02.06996c35.jpg";